/*
 * Gets a string representing the current module
 * It should be 'mail', 'calendar', 'files', 'people', 'tasks'
 */
export function getCurrentModule(): string {
    let location = window.location.pathname;
    if (location.charAt(location.length - 1) === '/') {
        location = location.substr(0, location.length - 1);
    }

    const index = location.indexOf('/');
    const path = location.substr(index + 1);
    return index === -1 ? location : path.split('/')[0];
}
